import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { AccessPage } from './pages/AccessPage';
import { Modulo2Page } from './pages/Modulo2Page';
import { Modulo3Page } from './pages/Modulo3Page';
import { Modulo4Page } from './pages/Modulo4Page';
import { SignupPage } from './pages/SignupPage';
import { LoginPage } from './pages/LoginPage';
import { CalculadoraPage } from './pages/CalculadoraPage';
export function App() {
  const path = window.location.pathname;
  if (path === '/calculadora') {
    return <CalculadoraPage data-id="element-0" />;
  }
  if (path === '/checkout') {
    return <CheckoutPage data-id="element-1" />;
  }
  if (path === '/member-signup') {
    return <SignupPage data-id="element-2" />;
  }
  if (path === '/login') {
    return <LoginPage data-id="element-3" />;
  }
  if (path === '/modulo-1') {
    return <AccessPage data-id="element-4" />;
  }
  if (path === '/modulo-2') {
    return <Modulo2Page data-id="element-5" />;
  }
  if (path === '/modulo-3') {
    return <Modulo3Page data-id="element-6" />;
  }
  if (path === '/modulo-4') {
    return <Modulo4Page data-id="element-7" />;
  }
  return <LandingPage data-id="element-8" />;
}